module.exports = __webpack_public_path__ + "img/image_3-fe943685.png";